import { ReactElement } from 'react';

const Footer = (): ReactElement => {
  return (
    <footer>
      <div className="pull-right">
        <img
          src="/build/images/nuvySoftLogo.png"
          alt="NuvySoft Logo"
          style={{ width: '160px', height: 'auto', display: 'block', margin: '0 auto 1rem' }}
        />
      </div>
    </footer>
  );
};

export default Footer;
